import { Component, OnInit, Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from './authentication.service';
import { environment } from 'src/environments/environment';
import { SpecialProjectCheck } from 'src/app/shared/services/common/special-project-check';
import { GlobalConstants } from 'src/app/pages/common/global-variables';


const loginApis = [
  'cs/v1/bins/validate'
]

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    @Inject(DOCUMENT) private document: any,
    public GlobalConstants: GlobalConstants,
    public SpecialProjectCheck: SpecialProjectCheck
  ) { }
  clientId: any;
  projectId: any;
  projectCode: string;
  environment_type: any;
  dynamicProjectId: any;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes("restcountries") || request.url.includes("ipify.org") || request.url.includes("postalpincode") || request.url.includes("opencagedata")) {
      return next.handle(request);
    }
    this.dynamicProjectId = false;
    this.environment_type = this.document.location.hostname.includes("sandbox") ? 'sandbox' : 'prod';
    this.clientId = this.GlobalConstants.data.x_header[this.environment_type].client_id;

    if(this.SpecialProjectCheck.checkProject().type === 'special'){      
      this.dynamicProjectId = true;
      this.projectCode = this.SpecialProjectCheck.checkProject().code;
    }
    if(loginApis.some(v => request.url.includes(v)) && (localStorage.getItem('redirectData') || localStorage.getItem('headerLogin'))){
      var redirectData = JSON.parse(localStorage.getItem('redirectData'));
      var headerLogin = localStorage.getItem('headerLogin');
      if(headerLogin){
        this.projectId = this.GlobalConstants.data.x_header[this.environment_type].main_project;
      }
      else if(redirectData){
        this.projectId = redirectData.projectId
      }
    }
    else if (this.dynamicProjectId) {
      this.projectId = this.GlobalConstants.data.x_header[this.environment_type][this.projectCode];
    }
    else{
      this.projectId = this.GlobalConstants.data.x_header[this.environment_type].main_project;
    }

    request = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '-1',
        'X-Download-Options': 'noopen',
        'X-Client-Id': this.clientId
      }
    });
    if(!request.headers.get('exclude_project_id')){
      request = request.clone({
        setHeaders: {
          'X-Project-Id': this.projectId
        }
      });
    }
    if(this.GlobalConstants.client === "smeoffers" ) {
      request = request.clone({ withCredentials: true });
    }
    if (localStorage.getItem('userCountry')) {
      let userCountry = JSON.parse(localStorage.getItem('userCountry'));
      if(userCountry.id){
        request = request.clone({
          setHeaders: {
            'X-Country-Id': userCountry.id
          }
        });
      }

    }
    if (sessionStorage.getItem("userLanguage")) {
      let userLanguage = JSON.parse(sessionStorage.getItem('userLanguage'));
      request = request.clone({
        setHeaders: {
          'X-Language-Id': userLanguage.id ? userLanguage.id : userLanguage.attributes.id
        }
      });
    }
    
    if (this.GlobalConstants.data.bin_login && localStorage.getItem('cb')) {
      let cb = localStorage.getItem('cb');
      if (cb) {
        request = request.clone({
          setHeaders: {
            'X-Login-Bin': atob(cb)
          }
        });
      }
    }

    var currentUser;
    if (localStorage.getItem('currentUser')) {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
      // if (currentUser && currentUser.token && (request.headers.get('exclude_token_add') !== 'true')) {
      if (currentUser && currentUser.token) {
        request = request.clone({
          setHeaders: {
            'Authorization': 'Bearer ' + currentUser.token
          }
        });
      }
    }

    return next.handle(request)
      .pipe(
        tap(
          (response: HttpEvent<any>) => {
            return response
          },
          (error: HttpErrorResponse) => {
            return error
          },
          () => {
          }
        )
      )
  }
}
